<template>
  <div :class="[
    'input',
    'input-date',
    { '-has-error': errorMessage || hasError },
    { '-is-disabled': disabled },
    { '-is-focused': isFocused },
  ]">
    <label v-if="!!label" :for="id" class="input__label">
      {{ computedLabel }}
    </label>
    <div class="input__wr input-date__wr">
      <input :id="id" ref="$input" v-model="value" :name="id" :inputmode="inputmode" :required="required"
             :autofocus="autofocus" :disabled="disabled" :aria-required="required" :autocomplete="autocomplete"
             :placeholder="placeholder" :type="inputType" :min="min" v-bind="listeners" class="input__field" />

      <base-icon v-if="isPasswd" :name="passwdIcon" class="input-date__icon" @click="showPasswd = !showPasswd" />
    </div>

    <span v-show="!!errorMessage" class="input__error">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script setup>
import { useField } from 'vee-validate'

const props = defineProps({
  name: String,
  id: {
    type: String,
    required: true
  },
  inputmode: String,
  autofocus: Boolean,
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: String,
  autocomplete: String,
  focused: Boolean,
  initialValue: [
    String,
    Number,
    Boolean
  ],
  modelValue: String,
  label: String,
  hasError: {
    type: Boolean,
    default: false
  },
  min: {
    type: String,
  },
  max: {
    type: String,
    default: new Date().toLocaleDateString("it-IT")
  },
  isDate: {
    type: Boolean,
    default: true
  },
  isTime: {
    type: Boolean,
    default: false
  },
  isDateTime: {
    type: Boolean,
    default: false
  },
})

const $input = ref(null)
const isFocused = ref(props.focused)

const inputType = computed(() => {
  if (props.isDateTime) return 'datetime-local'
  if (props.isTime) return 'time'
  return 'date'
})

const isPasswd = computed(() => props.type && props.type.includes('password'))
const showPasswd = ref(false)
const passwdIcon = computed(() => showPasswd.value ? 'barred-eye' : 'eye')
const computedType = computed(() => showPasswd.value ? 'text' : props.type)

const emit = defineEmits([
  'focus',
  'blur',
  'update:modelValue'
])

const computedLabel = computed(() => {
  return `${props.label}${props.required ? '*' : ''}`
})

const {
  value,
  errorMessage,
  handleBlur
} = useField(() => props.name, undefined, {
  validateOnValueUpdate: false,
  syncVModel: true,
  ...(props.initialValue ? { initialValue: props.initialValue } : {})
})

const listeners = {
  onFocus: event => {
    isFocused.value = true
    $input.value?.focus({ preventScroll: true })
    emit('focus', event)
  },
  onBlur: event => {
    isFocused.value = false
    $input.value?.blur()
    handleBlur(event, true)
    emit('blur', event)
  }
}
</script>

<style lang="scss" scoped>
.input-date {
  @include input-main;

  .input-date__icon {
    width: 24px;
    height: 24px;
    padding: 5px;
    cursor: pointer;
  }
}
</style>
